import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_IDEAL_DETAILS: MijnRoute = {
    path: 'details',
    navigationEvent: 'toIdealZelfserviceDetails',
    regex: /^\/zelf-regelen\/ideal\/details$/,
    webcomponent: 'mijn-ideal-zelfservice-webcomponent',
    internalPath: '/details'
};
